var window=global;var $CLJS=require("./cljs_env.js");require("./cljs.core.js");
'use strict';$CLJS.aZ=new $CLJS.M(null,"force?","force?",1839038675);$CLJS.bZ=new $CLJS.M(null,"cache-fn","cache-fn",5561939);